import axios from "axios";
import {
  pawnshop_reports_reader_service,
  pawnshop_reports_reader_service_v3,
  pawnshop_reports_reader_service_v4,
  pawnshop_reports_settings_service,
} from "./restclient";

export const compileInterceptors = (keycloak) => {
  const services = [
    pawnshop_reports_reader_service,
    pawnshop_reports_settings_service,
    pawnshop_reports_reader_service_v3,
    pawnshop_reports_reader_service_v4,
  ];

  CompileLogService(keycloak, services);
};

const CompileLogService = (keycloak, services) => {
  services.forEach((service) => {
    service.axiosInstance.interceptors.request.use((req) => {
      if (keycloak.isTokenExpired(0)) {
        keycloak
          .updateToken(5)
          .then(() => {})
          .catch(keycloak.login);
      }

      req.headers.Authorization = "Bearer " + keycloak.token;

      return req;
    });

    service.axiosInstance.interceptors.response.use(
      (resp) => {
        return resp;
      },
      (err) => {
      }
    );
  });
};
